import { initSearch, globalSearch, fixedsHeader, generateColors } from "@common/utils/initUtils";
import { createdThumbs, injectToChar } from "@common/utils/swiperUtils";
import { handleSendInquiry, ImportBundle, isMobile, lazyLoad, resetImgSize } from "@common/utils/utils";
import Swiper from "swiper11";
import { Autoplay, Navigation, Pagination, Thumbs } from "swiper11/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from "@common/utils/utils";
import { presetGSAP_IN, swiperGsapTimeline, YIGEAnimation } from "@common/utils/gsapUtils";
import { countUp } from "@common/utils/additionalUtils";
// import * as THREE from "three";
// import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib.js";
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("touchmove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});

/*! Event End */
let initFunction = () => {
  ImportBundle({ type: "css", onlyIndex: true }, ["https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css"]);
  window.lazyInstance = lazyLoad();
  initEvent();
  initSwiper();
  initFunction = () => {};
};
function initEvent() {
  new YIGEAnimation({
    start: isMobile(1024) ? "top bottom" : "top bottom-=15%",
  });
  ScrollTrigger.refresh();
  initSearch();
  globalSearch();
  fixedsHeader("page__header");
  generateColors($("html body").css("--themeColor"), { setTo: true });
  resetImgSize({ nodeList: $("._index_ .index-category .product-main .img-wrap .img"), setBox: true, setImg: false });
  countUp({
    target: ".counter",
    useGrouping: true,
  });
  (() => {
    if (isMobile()) return;
    let sameFlag = false;
    const lineCanvas = new CanvasLinesRenderer({
      pointGroupList: $("._index_ .index-category .product-main .point-list > li"),
      container: $("._index_ .index-category .product-main")[0],
      drawOnInit: false,
    });
    const triggerFn = (e: JQuery.ClickEvent | JQuery.MouseEnterEvent) => {
      const p = $(e.currentTarget);
      const PA = { el: p.find(".point-A")[0] };
      const PB = { el: p.find(".point-B")[0] };
      lineCanvas.lineDatas.forEach((line) => {
        const { PA } = line;
        if (PA.el === p.find(".point-A")[0]) {
          sameFlag = true;
        } else {
          sameFlag = false;
        }
      });
      if (!sameFlag) {
        lineCanvas.drawLines([{ PA, PB }]);
      }
    };
    if (!isMobile(1024)) {
      $("._index_ .index-category .product-main .point-list > li").on("mouseenter", triggerFn);
    } else {
      $("._index_ .index-category .product-main .point-list > li").on("click", triggerFn);
    }
  })();

  // lineBox in About
  (() => {
    const lineBox = $("._index_ .index-about .line-box");
    const lines = lineBox.find(".line");
    if (!lineBox.length) return;
    const count = lines.length;
    const gap = (lineBox.width() || 0) / (count - 1);
    lines.each((i, L) => {
      $(L).css("left", gap * i + "px");
    });
  })();
  // createLightScene($("._index_ .index-new")[0], "#032c5b");
  $("#IndexForm input,textarea").on("blur", (e) => {
    const target = $(e.currentTarget);
    const parent = target.parents(".input-box");
    if (target.val()) {
      parent.addClass("valid");
    } else {
      parent.removeClass("valid");
    }
  });
  handleSendInquiry({
    formId: "#IndexForm",
    trigger: "#IndexSubmit",
  });
  (() => {
    const selector = $("._index_ .index-contact");
    if (!selector.length) return;
    const coverBox = selector.find(".cover-box");
    const title = selector.find(".contact-right .index-title");
    const inputBox = selector.find(".contact-right .input-box");
    const { fadeInUp, clipInLeft } = presetGSAP_IN();
    ScrollTrigger.create({
      trigger: selector,
      start: "top bottom+=15%",
      once: true,
      onEnter: () => {
        const T = gsap.timeline({
          scrollTrigger: {
            trigger: selector,
            start: "top bottom-=20%",
            end: "top bottom-=20%",
            once: true,
          },
        });
        T.from(coverBox, {
          "--skewDeg": "0deg",
          "--clip": "100%",
        });
        T.from(title, fadeInUp, "<50%");
        T.from(inputBox, { ...clipInLeft, stagger: 0.15 }, "<");
      },
    });
  })();
}
function initSwiper() {
  injectToChar();
  new Swiper("._index_ .index-banner .swiper-box .swiper", {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    speed: 860,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    watchSlidesProgress: true,
    navigation: {
      prevEl: "._index_ .index-banner .swiper-box .prev",
      nextEl: "._index_ .index-banner .swiper-box .next",
    },
    pagination: {
      type: "progressbar",
      el: "._index_ .index-banner .swiper-box .navigation",
    },
    on: {
      init: (swiper) => {
        $("._index_ .index-banner .swiper-box .total").text(swiper.toChar(swiper.slides.length));
      },
      slideChangeTransitionStart: (swiper) => {
        $("._index_ .index-banner .swiper-box .current").text(swiper.toChar(swiper.realIndex + 1));
      },
    },
  });
  new Swiper("._index_ .index-product .swiper-box .swiper", {
    modules: [Autoplay],
    loop: true,
    autoplay: {
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 860,
    slidesPerView: 3,
    spaceBetween: 100,
    centeredSlides: true,
    centeredSlidesBounds: true,
    watchSlidesProgress: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 100,
      },
      620: {
        slidesPerView: "auto",
        spaceBetween: 60,
        // centeredSlides: false,
        centeredSlidesBounds: false,
      },
      150: {
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
    on: {
      init: (swiper) => {
        // 如果 slide 数量不足则关闭 loop
        if (swiper.slides.length <= Number(swiper.params.slidesPerView)) {
          swiper.params.loop = false;
        }
        const { clipInUp, clipInCenter, scaleInCenter } = presetGSAP_IN({ stagger: 0.15 });
        const title = $(swiper.visibleSlides).find(".index-sec-title");
        const imgWrap = $(swiper.visibleSlides).find(".img-wrap");

        const T = swiperGsapTimeline(swiper);
        T?.from(title, clipInUp, 0);
        T?.from(imgWrap, { ...clipInCenter, ...scaleInCenter }, 0);
      },
    },
  });

  new Swiper("._index_ .index-case .swiper-box.main .swiper", {
    modules: [Thumbs],
    loop: true,
    speed: 650,
    spaceBetween: 60,
    watchSlidesProgress: true,
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, "._index_ .index-case .swiper-box.thumbs .swiper", {
          cloneTarget: ".thumb-item",
          swiperOptions: {
            slidesPerView: 4,
            spaceBetween: 12,
            watchSlidesProgress: true,
            breakpoints: {
              1200: {
                slidesPerView: 4,
                spaceBetween: 12,
              },
              620: {
                slidesPerView: "auto",
                spaceBetween: 15,
              },
            },
            on: {
              init: (swiper) => {
                const t = swiperGsapTimeline(swiper, {
                  start: "bottom bottom",
                });
                const item = $(swiper.visibleSlides).find(".thumb-item");
                const icon = $(swiper.visibleSlides).find(".img-box");
                const title = $(swiper.visibleSlides).find("h3");
                const { clipInCenter, fadeInUp, clipInLeft } = presetGSAP_IN({ stagger: 0.1 });
                t?.from(item, clipInLeft, 0);
                t?.from(icon, clipInCenter, 0);
                t?.from(title, fadeInUp, 0);
              },
            },
          },
        });
        const slides = $(swiper.el).find(".swiper-slide .thumb-item");
        const imgs = slides.map((i, slide) => $(slide).attr("data-img") || "");
        const fragment = document.createDocumentFragment();
        imgs.each((i, src) => {
          const imgwrap = $(`
            <div class='img-wrap'>
              <div class='img-box'>
                <img class='img' yige-src='${src}' />
              </div>
            </div>
            `);
          fragment.appendChild(imgwrap[0]);
        });
        $("._index_ .index-case .background-imgs").append(fragment);
      },
      init: (swiper) => {
        $("._index_ .index-case .background-imgs .img-wrap").eq(swiper.realIndex).addClass("active");
        const T = swiperGsapTimeline(swiper);
        const title = $(swiper.visibleSlides).find("header > h3");
        const des = $(swiper.visibleSlides).find(".index-des");
        const { fadeInLeft } = presetGSAP_IN();
        T?.from(title, fadeInLeft);
        T?.from(des, fadeInLeft, "<25%");
      },
      slideChangeTransitionStart: (swiper) => {
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
        swiper.allowTouchMove = false;
        const imgList = $("._index_ .index-case .background-imgs .img-wrap");
        const prevImg = imgList.filter((i, img) => $(img).hasClass("active"));
        const currentImg = imgList.eq(swiper.realIndex);
        gsap
          .timeline({
            onComplete: () => {
              swiper.allowSlideNext = true;
              swiper.allowSlidePrev = true;
              swiper.allowTouchMove = true;
            },
          })
          .call(() => {
            currentImg.addClass("active");
          })
          .to(
            prevImg,
            {
              clipPath: "inset(0% 100% 0% 0%)",
              duration: (swiper.params.speed || 500 + 350) / 1000,
            },
            "<"
          )
          .fromTo(
            currentImg,
            {
              clipPath: "inset(0% 0% 0% 100%)",
            },
            {
              clipPath: "inset(0% 0% 0% 0%)",
              duration: (swiper.params.speed || 500) / 1000,
            },
            "<"
          )
          .call(() => {
            currentImg.siblings().removeClass("active");
          }, []);
      },
    },
  });
  new Swiper("._index_ .index-new .swiper-box .swiper", {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 140,
    speed: 750,
    watchSlidesProgress: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 140,
      },
      620: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      150: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
    on: {
      breakpoint: (swiper, breakpointParams) => {
        const container = $("._index_ .index-new");
        let box = container.find(".line-box");
        if (!container.length) return;
        const views = Number(swiper.params.slidesPerView || breakpointParams.slidesPerView || 0);
        const gap = Number(swiper.params.spaceBetween || breakpointParams.spaceBetween || 0);
        if (!box.length) {
          box = $(`<div class='line-box'></div>`);
          container.append(box);
        }
        box.empty();
        const W = box.width() || 0;

        const slidesWidth = (W - gap * (views - 1)) / views;
        for (let i = 0; i < views - 1; i++) {
          const slidesGap = gap / 2;
          const lineOffset = (gap / 2) * i;
          const L = $(`<span class='line' style='left: ${(slidesWidth + slidesGap) * (i + 1) + lineOffset}px'></span>`);
          box.append(L);
        }
      },
      init: (swiper) => {
        const imgWrap = $(swiper.visibleSlides).find(".img-wrap");
        const imgBox = $(swiper.visibleSlides).find(".img-wrap .img-box");
        const title = $(swiper.visibleSlides).find(".title");
        const bottom = $(swiper.visibleSlides).find(".bottom");

        const { clipInCenter, scaleInCenter, clipInUp, fadeInLeft } = presetGSAP_IN({ stagger: 0.15 });
        const T = swiperGsapTimeline(swiper);
        T?.from(imgWrap, clipInCenter, 0);
        T?.from(imgBox, scaleInCenter, 0);
        T?.from(title, clipInUp, "<5%");
        T?.from(bottom, fadeInLeft, "<10%");
      },
    },
  });
  window.lazyInstance.update();
}

// 类型定义扩展
interface CanvasLinesClass {
  pointGroup?: JQuery<HTMLElement>;
  pointDatas?: CanvasLinesPointType;
  lineDatas: CanvasLinesPointType;
  container?: HTMLElement;
  canvas: {
    el: HTMLCanvasElement;
    top: number;
    left: number;
    width: number;
    height: number;
  };
  params: CanvasLinesConstructor;
  update: (reInit?: boolean) => void;
  drawLines: (pointList?: CanvasLinesPointType) => Promise<void>;
}
interface CanvasLinesConstructor {
  pointGroupList: JQuery<HTMLElement>;
  container: HTMLElement;
  drawOnInit?: boolean;
  animate?: {
    animateDuration?: number;
    animateEase?: string;
  };
}
type CanvasLinesPointPositionType = {
  el: HTMLElement;
  left?: number;
  top?: number;
  width?: number;
  height?: number;
};
type CanvasLinesPointType = {
  PA: CanvasLinesPointPositionType;
  PB: CanvasLinesPointPositionType;
}[];
// 新增 Point 类型
interface CanvasLinesPoint {
  x: number;
  y: number;
}

class CanvasLinesRenderer implements CanvasLinesClass {
  public pointGroup: JQuery<HTMLElement> | undefined;
  public pointDatas: CanvasLinesPointType | undefined;
  public lineDatas: CanvasLinesPointType = [];
  public container: HTMLElement | undefined;
  public params: CanvasLinesConstructor;
  public canvas = {
    el: document.createElement("canvas"),
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  };

  private readonly dpr: number = window.devicePixelRatio || 1;
  private resizeObserver?: ResizeObserver;
  private mutationObserver?: MutationObserver;
  private static readonly SAFETY_MARGIN: number = 2;

  // 标志：是否允许自动渲染（初始化后自动绘制连线）
  private autoRender: boolean = false;
  // 用于保存当前的 gsap 动画实例，防止连续点击造成动画重叠
  private activeTweens: gsap.core.Tween[] = [];

  constructor(opts: CanvasLinesConstructor) {
    this.pointGroup = opts.pointGroupList;
    this.container = opts.container;
    this.params = opts;
    if (!opts.pointGroupList || !opts.container) {
      return;
    }
    // 只有当 drawOnInit 明确为 false 时，禁用自动渲染
    this.autoRender = opts.drawOnInit !== false;

    // 计算所有点的位置
    this.pointDatas = this.computePointPositions(this.pointGroup);
    // 将 canvas 元素添加到容器中
    this.container.append(this.canvas.el);
    if (this.autoRender) {
      // 自动绘制：使用计算出的点数据，并进行首次渲染
      this.lineDatas = this.pointDatas;
      this.render();
    } else {
      // 禁止自动绘制时，初始时不设置线条数据
      this.lineDatas = [];
    }

    this.bindListeners();
  }

  /**
   * 解析所有节点，设置 CSS 定位，并计算出各点数据
   */
  private computePointPositions(groupList: JQuery<HTMLElement>): CanvasLinesPointType {
    const positions: CanvasLinesPointType = [];
    groupList.each((_, element) => {
      const $element = $(element);
      const $pointA = $element.find(".point-A");
      const $pointB = $element.find(".point-B");

      ["A", "B"].forEach((point) => {
        const $pointEl = point === "A" ? $pointA : $pointB;
        const posLeft: number = Number($element.attr(`point${point}-pos-left`));
        const posTop: number = Number($element.attr(`point${point}-pos-top`));
        $pointEl.css({
          left: `${posLeft}%`,
          top: `${posTop}%`,
          position: "absolute",
          zIndex: point === "A" ? 9 : 8,
        });
      });

      positions.push({
        PA: { el: $pointA[0] },
        PB: { el: $pointB[0] },
      });
    });
    return positions;
  }

  /**
   * 更新 canvas 的尺寸与位置，使其能完全覆盖所有连线端点（含安全边距）
   */
  private updateCanvasDimensions(positions?: CanvasLinesPointType): void {
    let minLeft: number = Infinity,
      maxRight: number = -Infinity,
      minTop: number = Infinity,
      maxBottom: number = -Infinity;
    const posList = positions || this.computePointPositions(this.pointGroup!);

    // 缓存容器边界，避免重复计算
    const containerRect = this.container!.getBoundingClientRect();

    posList.forEach(({ PA, PB }) => {
      [PA.el, PB.el].forEach((el) => {
        const rect = el.getBoundingClientRect();
        const left = rect.left - containerRect.left;
        const top = rect.top - containerRect.top;
        const right = left + rect.width;
        const bottom = top + rect.height;
        minLeft = Math.min(minLeft, left);
        maxRight = Math.max(maxRight, right);
        minTop = Math.min(minTop, top);
        maxBottom = Math.max(maxBottom, bottom);
      });
    });

    this.canvas.left = Math.floor(minLeft - CanvasLinesRenderer.SAFETY_MARGIN);
    this.canvas.top = Math.floor(minTop - CanvasLinesRenderer.SAFETY_MARGIN);
    this.canvas.width = Math.ceil(maxRight - minLeft + CanvasLinesRenderer.SAFETY_MARGIN * 2);
    this.canvas.height = Math.ceil(maxBottom - minTop + CanvasLinesRenderer.SAFETY_MARGIN * 2);

    // 设置 canvas 物理尺寸与样式尺寸
    this.canvas.el.width = this.canvas.width * this.dpr;
    this.canvas.el.height = this.canvas.height * this.dpr;
    this.canvas.el.style.width = `${this.canvas.width}px`;
    this.canvas.el.style.height = `${this.canvas.height}px`;

    $(this.canvas.el).css({
      position: "absolute",
      top: `${this.canvas.top}px`,
      left: `${this.canvas.left}px`,
      transform: "translateZ(0)", // 触发 GPU 加速
    });
  }

  /**
   * 计算元素相对于 canvas 的位置，并进行像素对齐处理
   */
  private getRelativePosition(el: HTMLElement): CanvasLinesPoint {
    const elementRect = el.getBoundingClientRect();
    const containerRect = this.container!.getBoundingClientRect();

    const rawX = elementRect.left - containerRect.left - this.canvas.left;
    const rawY = elementRect.top - containerRect.top - this.canvas.top;

    return {
      x: this.alignToPixel(rawX),
      y: this.alignToPixel(rawY),
    };
  }

  /**
   * 像素对齐处理，确保在高 DPI 设备上绘制更清晰
   */
  private alignToPixel(value: number): number {
    return Math.round(value * this.dpr) / this.dpr;
  }

  /**
   * 绘制所有连线（支持动画），返回 Promise 以便等待动画结束
   */
  public async drawLines(pointList?: CanvasLinesPointType): Promise<void> {
    const ctx = this.canvas.el.getContext("2d", { antialias: true }) as CanvasRenderingContext2D;
    if (!ctx) return;
    if (pointList) {
      this.lineDatas = pointList;
    }

    // 取消之前所有正在运行的动画，防止连续点击时产生重叠绘制
    if (this.activeTweens.length > 0) {
      this.activeTweens.forEach((tween) => {
        tween.progress(1);
        tween.kill();
      });
      this.activeTweens = [];
    }

    ctx.save();
    ctx.scale(this.dpr, this.dpr);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.lineWidth = 1.5;
    ctx.strokeStyle = "#075cbd";
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    const drawPromises: Promise<void>[] = this.lineDatas.map(({ PA, PB }) => {
      const paPos = this.getRelativePosition(PA.el);
      const pbPos = this.getRelativePosition(PB.el);

      const start: CanvasLinesPoint = {
        x: this.alignToPixel(paPos.x + PA.el.offsetWidth / 2),
        y: this.alignToPixel(paPos.y + PA.el.offsetHeight / 2),
      };

      const end: CanvasLinesPoint = {
        x: this.alignToPixel(pbPos.x + PB.el.offsetWidth / 2),
        y: this.alignToPixel(paPos.y < pbPos.y ? pbPos.y - 15 : pbPos.y + PB.el.offsetHeight + 15),
      };

      return this.drawAnimatedLine(ctx, start, end, PA, PB);
    });

    await Promise.all(drawPromises);
    ctx.restore();
  }
  /**
   * 使用 gsap 动画绘制单条连线，逐步显示路径
   */
  private drawAnimatedLine(
    ctx: CanvasRenderingContext2D,
    start: CanvasLinesPoint,
    end: CanvasLinesPoint,
    pointA: CanvasLinesPointPositionType,
    pointB: CanvasLinesPointPositionType
  ): Promise<void> {
    const path = new Path2D();
    const controlPoint = this.calculateControlPoint(start, end);
    const circleRadius = 5;
    const lineToCircle = { x: end.x, y: end.y };

    if (Math.hypot(end.x - controlPoint.x, end.y - controlPoint.y) < circleRadius) {
      lineToCircle.x = controlPoint.x;
      lineToCircle.y = controlPoint.y;
    }
    const pathAngle = Math.atan2(end.y - controlPoint.y, end.x - controlPoint.x);
    lineToCircle.x = end.x - Math.cos(pathAngle) * circleRadius;
    lineToCircle.y = end.y - Math.sin(pathAngle) * circleRadius;

    path.moveTo(start.x, start.y);
    path.lineTo(controlPoint.x, controlPoint.y);
    path.lineTo(lineToCircle.x, lineToCircle.y);
    path.arc(end.x, end.y, circleRadius, 0, Math.PI * 2);

    const totalLength = this.calculatePathLength(start, controlPoint, lineToCircle);

    return new Promise((resolve) => {
      const animationState = { progress: 0 };
      const tween = gsap.to(animationState, {
        progress: 1,
        duration: this.params.animate?.animateDuration || 0.65,
        ease: this.params.animate?.animateEase || "power3.out",
        onUpdate: () => {
          const minX = Math.min(start.x, controlPoint.x, end.x) - circleRadius / 2;
          const minY = Math.min(start.y, controlPoint.y, end.y) - circleRadius / 2;
          const maxX = Math.max(start.x, controlPoint.x, end.x);
          const maxY = Math.max(start.y, controlPoint.y, end.y);
          ctx.clearRect(minX, minY, maxX - minX + circleRadius, maxY - minY + circleRadius);
          ctx.save();
          ctx.setLineDash([totalLength * animationState.progress, totalLength * 100]);
          ctx.stroke(path);
          ctx.restore();
        },
        onStart: () => {
          this.pointDatas?.forEach((point) => {
            gsap.to(point.PB.el, { autoAlpha: 0 });
          });
        },
        onComplete: () => {
          gsap.to(pointB.el, { autoAlpha: 1 });
          ctx.beginPath();
          ctx.arc(end.x, end.y, circleRadius, 0, Math.PI * 2);
          ctx.stroke();
          resolve();
        },
      });
      // 保存当前动画实例，便于后续取消
      this.activeTweens.push(tween);
    });
  }

  /**
   * 根据起点和终点计算曲线控制点
   */
  private calculateControlPoint(start: CanvasLinesPoint, end: CanvasLinesPoint): CanvasLinesPoint {
    const verticalDistance = Math.abs(end.y - start.y);
    return {
      x: start.x,
      y: start.y + (end.y > start.y ? verticalDistance * 0.8 : -verticalDistance * 0.8),
    };
  }

  /**
   * 计算路径总长度（从起点到控制点，再到终点边缘）
   */
  private calculatePathLength(start: CanvasLinesPoint, control: CanvasLinesPoint, end: CanvasLinesPoint): number {
    return Math.hypot(control.x - start.x, control.y - start.y) + Math.hypot(end.x - control.x, end.y - control.y);
  }

  /**
   * 绑定 ResizeObserver 与 MutationObserver，并使用 debounce 防止频繁更新
   */
  private bindListeners(): void {
    const debouncedUpdate = debounce(() => this.update(), 300);
    this.resizeObserver = new ResizeObserver(debouncedUpdate);
    this.resizeObserver.observe(this.container!);
    this.mutationObserver = new MutationObserver(debouncedUpdate);
    this.mutationObserver.observe(this.container!, {
      attributeFilter: ["style", "class"],
    });
  }

  /**
   * 整体渲染流程：更新 canvas 尺寸并绘制所有连线
   */
  private render(): void {
    this.updateCanvasDimensions();
    this.drawLines();
  }

  /**
   * 更新方法：重新计算点数据和 canvas 尺寸
   * 当 reInit 为 true 时，从整体 pointGroup 重新计算，
   * 否则保留当前激活的 lineDatas（若存在）仅更新它们的位置
   */
  public update(reInit: boolean = false): void {
    this.updateCanvasDimensions();
    if (reInit) {
      const updatedPositions = this.computePointPositions(this.pointGroup!);
      this.pointDatas = updatedPositions;
      if (this.autoRender) {
        this.lineDatas = updatedPositions;
      }
      requestAnimationFrame(() => {
        this.drawLines();
      });
    } else {
      // this.updateCanvasDimensions();
      if (this.lineDatas && this.lineDatas.length > 0) {
        // 保留激活的连线，仅重新计算其位置信息
        this.drawLines(this.lineDatas);
      } else {
        // this.updateCanvasDimensions();
      }
    }
  }
}

/**
 * 在指定容器中创建一个玻璃平面（100×100）及多个随机矩形光源，
 * 所有光源均从画布下方随机位置发出白光，指向画布左上角。
 * @param container - 承载场景的 HTML 容器元素
 * @param bgColor - 渲染器背景色
 */
// function createLightScene(container: HTMLElement, bgColor: string) {
//   // 1. 创建渲染器
//   const renderer = new THREE.WebGLRenderer({ antialias: true });
//   renderer.setSize(container.clientWidth, container.clientHeight);
//   renderer.setPixelRatio(window.devicePixelRatio);
//   renderer.setClearColor(bgColor);
//   renderer.domElement.style.position = "absolute";
//   renderer.domElement.style.top = "0";
//   renderer.domElement.style.left = "0";
//   renderer.domElement.style.width = "100%";
//   renderer.domElement.style.height = "100%";
//   container.appendChild(renderer.domElement);

//   // 2. 创建场景
//   const scene = new THREE.Scene();

//   // 3. 创建相机
//   const camera = new THREE.PerspectiveCamera(45, container.clientWidth / container.clientHeight, 0.1, 1000);
//   camera.position.set(0, 0, 12); // 调整相机位置以便更好观察 100×100 的平面

//   // 4. 创建玻璃平面（100×100）
//   const planeGeometry = new THREE.PlaneGeometry(100, 100);
//   const planeMaterial = new THREE.MeshPhysicalMaterial({
//     color: 0x05448c,
//     roughness: 0.1,
//     transmission: 0.35, // 透射效果
//     thickness: 0.5,
//     reflectivity: 0.5,
//     ior: 1.2,
//     transparent: true,
//   });
//   const planeMesh = new THREE.Mesh(planeGeometry, planeMaterial);
//   planeMesh.rotation.x = -Math.PI / 9; // 约 20° 倾斜
//   scene.add(planeMesh);

//   // 5. 初始化矩形光源所需工具（请取消注释确保正常使用）
//   RectAreaLightUniformsLib.init();

//   // 6. 创建多个随机矩形光源
//   const numLights = 1; // 可根据需求调整光源数量
//   for (let i = 0; i < numLights; i++) {
//     // 随机宽度和高度（例如：宽度范围 [2,8]，高度范围 [1,4]）
//     // const width = Math.random() * 6 + 2;
//     const width = 5;
//     // const height = Math.random() * 3 + 1;
//     const height = 100;
//     const intensity = 10; // 如有需要可提高光强
//     const color = 0xffffff; // 白光

//     const rectLight = new THREE.RectAreaLight(color, intensity, width, height);

//     // 随机位置：保证位于画布下方（例如 y 在 [-8, -6] 之间，x 在 [-5, 5] 范围内，z 固定在 0）
//     // const xPos = Math.random() * 10 - 5;
//     const xPos = 0;
//     // const yPos = Math.random() * 2 - 8;
//     const yPos = -4.97;
//     const zPos = 0;
//     rectLight.position.set(xPos, yPos, zPos);

//     // 设置光源指向画布左上角（场景中左上角点 (-50, 50, 0)）
//     rectLight.lookAt(new THREE.Vector3(0, 50, 0));

//     scene.add(rectLight);

//     // 添加辅助工具显示矩形光源位置和方向，便于调试
//     // const rectLightHelper = new RectAreaLightHelper(rectLight);
//     // rectLightHelper.visible = true
//     // rectLight.add(rectLightHelper);
//   }

//   // 7. 可选：添加环境光增强整体亮度
//   // const ambientLight = new THREE.AmbientLight(0xffffff);
//   // scene.add(ambientLight);

//   // 8. 监听窗口大小变化，更新相机和渲染器尺寸

//   const onWindowResize = () => {
//     const width = container.clientWidth;
//     const height = container.clientHeight;
//     camera.aspect = width / height;
//     camera.updateProjectionMatrix();
//     renderer.setSize(width, height);
//   };
//   window.addEventListener("resize", onWindowResize);

//   // 9. 动画循环渲染
//   const animate = () => {
//     requestAnimationFrame(animate);
//     renderer.render(scene, camera);
//   };
//   animate();
// }
